/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Link_ClaimsInputs */

const en_dashboard_link_claims = /** @type {(inputs: Dashboard_Link_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to claims page`)
};

const fr_dashboard_link_claims = /** @type {(inputs: Dashboard_Link_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers la page des réclamations`)
};

/**
* | output |
* | --- |
* | "Link to claims page" |
*
* @param {Dashboard_Link_ClaimsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_link_claims = /** @type {((inputs?: Dashboard_Link_ClaimsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Link_ClaimsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_link_claims(inputs)
	return fr_dashboard_link_claims(inputs)
});